import { Button, Checkbox, DialogActions, DialogContent, DialogTitle, List, ListItemButton, Stack, Typography } from "@mui/material"
import LayersIcon from "components/icons/other/layers"
import saveAs from "file-saver"
import { observer } from "mobx-react-lite"
import { useState } from "react"
import { useMainStore } from "store"
import { num } from "utils/lang"
import ExportSchemesDialogStore from "./store"

const ExportSchemesDialog = observer(() => {

  const mainStore = useMainStore()
  const [ store ] = useState(() => new ExportSchemesDialogStore(Array.from(mainStore.schemes.values()).map(item => item.id)))

  const applyExport = () => {
    
    const schemes = Object.fromEntries(
      Array.from(store.val)
        .filter(schemeId => mainStore.schemes.has(schemeId))
        .map(schemeId => [ schemeId, mainStore.schemes.get(schemeId)!.data ])
    )

    const file = new File([ JSON.stringify({ schemes }) ], "schemes.json", { type: "application/json" })
    saveAs(file)
  }

  return (
    <>
      <DialogTitle>Экспорт схем</DialogTitle>
      <DialogContent>
        <List disablePadding sx={{ width: 370 }}>
        { Array.from(mainStore.schemes.values()).map(scheme => (
          <ListItemButton
            sx={{ px: 0, borderBottom: 1, borderColor: "divider", color: store.val.has(scheme.id)? "text.primary": "text.secondary" }}
            onClick={() => store.toggle(scheme.id)}
            key={scheme.id}
          >
            <LayersIcon sx={{ fontSize: 19 }}/>
            <Stack ml={1.5} flexGrow={1}>
              <Typography fontWeight={600} fontSize={12}>{ scheme.data.name }</Typography>
              <Typography fontSize={10}>{ num(Object.keys(scheme.data.blocks).length, "блок", "блока", "блоков") }</Typography>
            </Stack>
            <Checkbox 
              checked={store.val.has(scheme.id)} 
            />
          </ListItemButton>
        )) }
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={applyExport} disabled={store.val.size === 0} variant="contained" color="secondary">
          Экспорт в файл
        </Button>
      </DialogActions>
    </>
  )
})

export default ExportSchemesDialog